import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { HealthServicesLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";

const Health_Desease_control = () => {
  const { t } = useTranslation();

  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="img" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
            <div className="site-menu  min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {HealthServicesLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2 bas">
                    <h3 className="fontSizeClass"> {t("Desease Control")} </h3>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="dig-login1 dig-login2">
                        <h5 className="list-header-h3">
                          {t("COMMUNICABLE DISEASE")}
                        </h5>
                        <div className="accordion-body desease-list">
                          <ul className="kmc-function-list">
                            <li>
                              {t("Vector Borne Disease: Dengue, Malaria")}
                            </li>
                            <li>
                              {t(
                                "Other Infectious Disease including TB, Respiratory Infection, Gastroenteritis"
                              )}
                            </li>
                            {/* <li>
                              {t(
                                "Carry out survey under the KMC area on Demographic, socio-economic & and level of services provided"
                              )}
                            </li> */}
                            <li>{t("Vaccine Preventable Disease")}</li>
                            {t("How to Control")}:
                            <li>
                              {t(
                                "Vector Borne Disease: By Vector control early diagnosis and treatment"
                              )}
                              .
                            </li>
                            {t("Treatment centre")}:
                            <li>{t("All 144 UPHCs")}</li>
                            <ul></ul>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="dig-login1 dig-login2">
                        <h5 className="list-header-h3">
                          {t("NON COMMUNICABLE DISEASE")}
                        </h5>
                        <div className="accordion-body desease-list">
                          <ul className="kmc-function-list">
                            <li>{t("Diabetes")}</li>
                            <li>{t("Hyper tension")}</li>
                            <li>{t("COPD")}</li>
                            <li>{t("Other Non-Communicable Disease")}</li>
                            {t("How to Control")}:
                            <li>
                              {t(
                                "By diagnosis with advance pathology and appropriate treatment"
                              )}
                              .
                            </li>
                            {t("Treatment centre")}:
                            <li>{t("All 144 UPHCs")}</li>
                            <ul></ul>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Health_Desease_control;
